const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null);

export const normalizeBookingService = (row = {}) => {
  const service = row.service || {};
  return {
    ...service,
    ...row,
    service_id: firstDefined(row.service_id, row.id, row.value, service.service_id, service.id),
    name: firstDefined(row.name, row.service_name, row.display_name, service.name, service.service_name, "Unnamed service"),
    duration_minutes: firstDefined(row.duration_minutes, row.duration, row.default_duration_minutes,
      service.duration_minutes, service.duration, 0),
    price: firstDefined(row.price, row.fee, row.amount, service.price, service.fee, 0),
    service_mode: firstDefined(row.service_mode, row.mode, service.service_mode, service.mode),
  };
};

export const normalizeDoctorServiceAssignment = (row = {}) => ({
  ...row,
  doctor_id: firstDefined(row.doctor_id, row.doctor?.doctor_id, row.doctor?.id),
  service_id: firstDefined(row.service_id, row.service?.service_id, row.service?.id),
});

export const doctorOffersService = (assignments, doctorId, serviceId) => assignments.some((row) => (
  row.doctor_id === doctorId && row.service_id === serviceId
));

export const effectiveBookingPrice = (services, assignments, doctorId, serviceId) => {
  const service = services.find((row) => row.service_id === serviceId);
  const assignment = assignments.find((row) => row.doctor_id === doctorId && row.service_id === serviceId);
  return assignment?.custom_fee !== undefined && assignment?.custom_fee !== null
    ? Number(assignment.custom_fee)
    : Number(service?.price || 0);
};
